import { createAction } from "@reduxjs/toolkit";

export const reset = createAction("reset");
export const resetPagination = createAction("resetPagination");
export const pushPreviousToken = createAction("pushPreviousToken");
export const popPreviousToken = createAction("popPreviousToken");